var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCdCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5607 0.43934C13.1464 1.02513 13.1464 1.97487 12.5607 2.56066L2.56066 12.5607C1.97487 13.1464 1.02513 13.1464 0.43934 12.5607C-0.146447 11.9749 -0.146447 11.0251 0.43934 10.4393L10.4393 0.43934C11.0251 -0.146447 11.9749 -0.146447 12.5607 0.43934Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.43934 0.43934C1.02513 -0.146447 1.97487 -0.146447 2.56066 0.43934L12.5607 10.4393C13.1464 11.0251 13.1464 11.9749 12.5607 12.5607C11.9749 13.1464 11.0251 13.1464 10.4393 12.5607L0.43934 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.43934 0.43934Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdCloseBtn);
export default __webpack_public_path__ + "static/media/cd-close-btn.b316f756d727ac2b9165a8f9d94774b2.svg";
export { ForwardRef as ReactComponent };